import React, { FC, useCallback } from 'react';

import { useRouter } from 'expo-router';
import { useStoreContext } from 'features/store';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { Typography } from 'components/ui';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useOrderContext } from 'state/order';
import { routes } from 'utils/routing';

/** dev only way to clear store */
export const ClearStoreSmButton: FC<React.PropsWithChildren<unknown>> = () => {
  const renderButton =
    useFlag(LaunchDarklyFlag.ENABLE_LOCATOR_CLEAR_STORE_AND_SM_BUTTON) || __DEV__;
  const { clearServerOrder } = useOrderContext();
  const { resetStore } = useStoreContext();
  const router = useRouter();

  const handleClick = useCallback(() => {
    clearServerOrder();
    resetStore();
    router.replace(routes.base);
  }, [clearServerOrder, router, resetStore]);

  if (!renderButton) {
    return null;
  }

  return (
    <TouchableOpacity style={styles.button} onPress={handleClick}>
      <Typography style={styles.text}>Clear Location</Typography>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 9999,
    borderColor: 'limegreen',
    backgroundColor: 'rgba(0,255,0,0.2)',
    borderWidth: 1,
  },
  text: {
    color: 'limegreen',
  },
});
